import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import { errorMessageAsString } from "@/utils/simple-error";
export const useObjectStoreInstancesStore = defineStore("objectStoreInstances", {
    state: () => ({
        instances: [],
        fetched: false,
        error: null,
    }),
    getters: {
        getInstances: (state) => {
            return state.instances;
        },
        loading: (state) => {
            return !state.fetched;
        },
        getInstance: (state) => {
            return (uuid) => state.instances.find((i) => i.uuid == uuid);
        },
    },
    actions: {
        async handleInit(instances) {
            this.instances = instances;
            this.fetched = true;
            this.error = null;
        },
        async handleError(err) {
            this.error = errorMessageAsString(err);
        },
        async fetchInstances() {
            const { data: instances, error } = await GalaxyApi().GET("/api/object_store_instances");
            if (error) {
                this.handleError(error);
                return;
            }
            this.handleInit(instances);
        },
        async ensureTemplates() {
            if (!this.fetched || this.error != null) {
                await this.fetchInstances();
            }
        },
    },
});
